import InterviewPracticeQuestionSelectCompanyList from './companyList';
import InterviewPracticeQuestionSelectCompanyQuestionList from './questionList';
import { useState } from 'react';
import classnames from 'classnames/bind';
import style from './company.module.scss';

const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectBodyCompany = () => {
  const [selectedCompanySn, setSelectedCompanySn] = useState<number | null>(null);

  return (
    <div className={cx('companyWrap')}>
      <InterviewPracticeQuestionSelectCompanyList
        selectedCompanySn={selectedCompanySn}
        setSelectedCompanySn={setSelectedCompanySn}
      />
      <InterviewPracticeQuestionSelectCompanyQuestionList selectedCompanySn={selectedCompanySn} />
    </div>
  );
};

export default InterviewPracticeQuestionSelectBodyCompany;
